// extracted by mini-css-extract-plugin
module.exports = {"loading":"Placeholder_loading__THAKk","loading-anim":"Placeholder_loading-anim__19cEg"};